//Reference: 
//https://www.onextrapixel.com/2012/12/10/how-to-create-a-custom-file-input-with-jquery-css3-and-php/
;(function($) {

          // Browser supports HTML5 multiple file?
          var multipleSupport = typeof $('<input/>')[0].multiple !== 'undefined',
              isIE = /msie/i.test( navigator.userAgent );

          $.fn.customFileUpload = function() {

            return this.each(function() {

              var $wrap = $(this),
                  $file = $wrap.find('input[type="file"]'), // the original file input
                  $poster = $wrap.find('div.js-message'),
                  $input = $wrap.find('div.js-uploaded'),
                  // Button that will be used in non-IE browsers
                  $button = $wrap.find('button'),
                  // Hack for IE
                  $label = $wrap.find('button');

              // Hide by shifting to the left so we
              // can still trigger events
              $file.css({
                position: 'absolute',
                left: '-9999px'
              });

              // Prevent focus
              $file.attr('tabIndex', -1);
              $button.attr('tabIndex', -1);

              $button.click(function (e) {
                e.preventDefault()
                $file.focus().click(); // Open dialog
              });

              $file.change(function() {

                var files = [], fileArr, filename;

                // If multiple is supported then extract
                // all filenames from the file array
                if ( multipleSupport ) {
                  fileArr = $file[0].files;
                  for ( var i = 0, len = fileArr.length; i < len; i++ ) {
                    files.push( fileArr[i].name );
                  }
                  filename = files.join(', ');

                // If not supported then just take the value
                // and remove the path to just show the filename
                } else {
                  filename = $file.val().split('\\').pop();
                }

                $poster.hide()
                $input.show()
                  .text( filename ) // Set the value
                  .attr('title', filename); // Show filename in title tootlip

                if (!filename.length) {
                  $poster.show()
                  $input.hide()
                }
              });
            });

          };

          // Old browser fallback
          if ( !multipleSupport ) {
            $( document ).on('change', 'input.customfile', function() {

              var $wrap = $(this),
                  // Create a unique ID so we
                  // can attach the label to the input
                  uniqId = 'customfile_'+ (new Date()).getTime(),

                  // Filter empty input
                  $inputs = $wrap.find('div.js-uploaded'),

                  $file = $wrap.find('input[type="file"]');

              // 1ms timeout so it runs after all other events
              // that modify the value have triggered
              setTimeout(function() {
                // Add a new input
                if ( $wrap.val() ) {
                  // Check for empty fields to prevent
                  // creating new inputs when changing files
                  if ( !$inputs.length ) {
                    $wrap.after( $file );
                    $file.customFileUpload();
                  }
                }
              }, 1);

            });
          }

}(jQuery));
